import { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Form, Button, Spinner, Modal } from "react-bootstrap";
import { FaKey } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "../forgotpassword.css";
import bgImage from "../assetss/login-bg.jpg";

export default function ForgotPassword() {
    const navigate = useNavigate();

    const [input, setInput] = useState("");
    const [touched, setTouched] = useState(false);
    const [loading, setLoading] = useState(false);

    const [otpModal, setOtpModal] = useState(false);
    const [generatedOtp, setGeneratedOtp] = useState("");
    const [timer, setTimer] = useState(30);

    const [otpValues, setOtpValues] = useState(["", "", "", "", "", ""]);
    const inputsRef = useRef([]);

    const [step, setStep] = useState("otp");

    const isValid = (val) =>
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val) || /^[0-9]{10}$/.test(val);

    const showError = touched && !isValid(input);


    useEffect(() => {
        let interval;
        if (otpModal && timer > 0) {
            interval = setInterval(() => {
                setTimer((prev) => prev - 1);
            }, 1000);
        }
        return () => clearInterval(interval);
    }, [otpModal, timer]);


    const generateOtp = () => {
        const otp = Math.floor(100000 + Math.random() * 900000).toString();
        console.log("OTP:", otp);
        setGeneratedOtp(otp);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setTouched(true);
        if (!isValid(input)) return;

        setLoading(true);

        setTimeout(() => {
            setLoading(false);
            generateOtp();
            setOtpModal(true);
            setTimer(30);
            setStep("otp");
        }, 1000);
    };


    const handleChange = (value, index) => {
        if (!/^\d?$/.test(value)) return;

        const newOtp = [...otpValues];
        newOtp[index] = value;
        setOtpValues(newOtp);

        if (value && index < 5) {
            inputsRef.current[index + 1].focus();
        }
    };


    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && !otpValues[index] && index > 0) {
            inputsRef.current[index - 1].focus();
        }
    };

    const verifyOtp = () => {
        const enteredOtp = otpValues.join("");
        if (enteredOtp === generatedOtp) {
            setStep("reset");
        } else {
            alert("Invalid OTP ");
        }
    };

    const handleResend = () => {
        generateOtp();
        setTimer(30);
        setOtpValues(["", "", "", "", "", ""]);
        inputsRef.current[0].focus();
    };

    const handleResetPassword = () => {
        setStep("success");

        setTimeout(() => {
            navigate("/");
        }, 2000);
    };

    return (
        <>
            <div className="fp-section"
                style={{
                    backgroundImage: `url(${bgImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    height: "100vh"
                }}
            >
                <Container>
                    <Row className="justify-content-center">
                        <Col xs={12} sm={10} md={6} lg={5}>
                            <div className="fp-card">

                                <div className="icon-wrap">
                                    <FaKey />
                                </div>

                                <div className="card-title">Forgot Password</div>
                                <div className="card-subtitle">
                                    Reset password using OTP
                                </div>

                                <Form onSubmit={handleSubmit}>
                                    <Form.Group className="mb-3">
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter email or mobile"
                                            value={input}
                                            onChange={(e) => setInput(e.target.value)}
                                            onBlur={() => setTouched(true)}
                                            className={showError ? "is-invalid fp-input" : "fp-input"}
                                            maxLength={10}
                                        />
                                        {showError && (
                                            <div className="invalid-feedback">
                                                Enter valid email or mobile
                                            </div>
                                        )}
                                    </Form.Group>

                                    <Button className="fp-btn" type="submit" disabled={loading}>
                                        {loading ? (
                                            <>
                                                <Spinner size="sm" className="me-2" />
                                                Sending OTP...
                                            </>
                                        ) : (
                                            "Send OTP"
                                        )}
                                    </Button>
                                </Form>

                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>


            <Modal centered show={otpModal} onHide={() => setOtpModal(false)}>
                <Modal.Body className="text-center p-4">

                    {step === "otp" && (
                        <>
                            <h5>Enter OTP</h5>
                            <p className="text-muted">{input}</p>

                            <div className="otp-container">
                                {otpValues.map((val, i) => (
                                    <input
                                        key={i}
                                        ref={(el) => (inputsRef.current[i] = el)}
                                        value={val}
                                        onChange={(e) => handleChange(e.target.value, i)}
                                        onKeyDown={(e) => handleKeyDown(e, i)}
                                        maxLength={1}
                                        className="otp-box"
                                    />
                                ))}
                            </div>

                            <Button className="fp-btn mt-3" onClick={verifyOtp}>
                                Verify OTP
                            </Button>

                            <div className="mt-2">
                                {timer > 0 ? (
                                    <small>Resend in {timer}s</small>
                                ) : (
                                    <Button variant="link" onClick={handleResend}>
                                        Resend OTP
                                    </Button>
                                )}
                            </div>
                        </>
                    )}

                    {step === "reset" && (
                        <>
                            <h5>Reset Password</h5>

                            <Form>
                                <Form.Control
                                    type="password"
                                    placeholder="Old Password"
                                    className="mb-2"
                                />
                                <Form.Control
                                    type="password"
                                    placeholder="New Password"
                                    className="mb-2"
                                />
                                <Form.Control
                                    type="password"
                                    placeholder="Confirm Password"
                                    className="mb-3"
                                />

                                <Button className="fp-btn" onClick={handleResetPassword}>
                                    Update Password
                                </Button>
                            </Form>
                        </>
                    )}

                    {step === "success" && (
                        <>
                            <h4>✅ Password Updated</h4>
                            <p>Redirecting to login...</p>
                        </>
                    )}

                </Modal.Body>
            </Modal>
        </>
    );
}